<template>
	<roles :breadcrumbs="breadcrumbArray" :note="'Create and manage the UNOapp Business roles.'" :businessId="1" :baseRoute="'/app/unoapp_business/roles'" :baseRouteName="'UNOapp Business Roles'"></roles>
</template>

<script>
import Roles from '../Roles/Roles'

/**
 * UNOapp Business Roles module is a page for the roles dashboard and creation process for the UNOapp Business.
 * @class UnoappBusinessRoles
 * @since 0.0.6
 */

export default {
	data () {
		return {
			breadcrumbArray: [
				{name: 'UNOapp Business', link: false},
				{name: 'Roles', link: false}
			]
		}
	},
	components: {
		Roles
	}
}
</script>


// WEBPACK FOOTER //
// Roles.vue?45af1499